import firebase from 'firebase/app';
import 'firebase/messaging';
import 'firebase/firestore';
import {firebaseConfig} from "config/enviroments";

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const messaging = firebase.messaging();